import React, { useEffect, useState } from 'react';
import { Command } from 'lucide-react';
import { DOMAIN } from '../mock';

const links = [
  { href: '#work', label: 'Work' },
  { href: '#practice', label: 'Practice' },
  { href: '#about', label: 'About' },
  { href: '#contact', label: 'Contact' },
];

export default function Nav({ onOpenCommand }) {
  const [scrolled, setScrolled] = useState(false);
  const [isMac, setIsMac] = useState(true);

  useEffect(() => {
    setIsMac(/Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || ''));
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? 'backdrop-blur-md' : ''
      }`}
      style={{
        background: scrolled ? 'rgba(244, 239, 230, 0.82)' : 'transparent',
        borderBottom: scrolled ? '1px solid rgba(15, 27, 20, 0.08)' : '1px solid transparent',
      }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 group">
          <span
            className="inline-block w-2 h-2 rounded-full"
            style={{ background: 'var(--forest)' }}
            aria-hidden
          />
          <span className="mono text-[13px] tracking-wide" style={{ color: 'var(--ink)' }}>
            {DOMAIN}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="mono text-[12px] uppercase tracking-[0.14em] link-line"
              style={{ color: 'var(--ink)' }}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            type="button"
            onClick={onOpenCommand}
            aria-label="Open command palette"
            className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full mono text-[10px] uppercase tracking-[0.16em]"
            style={{
              background: 'var(--bone-deep)',
              color: 'var(--forest)',
              border: '1px solid rgba(15,27,20,0.08)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--forest)';
              e.currentTarget.style.color = 'var(--cream)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'var(--bone-deep)';
              e.currentTarget.style.color = 'var(--forest)';
            }}
          >
            <Command size={11} strokeWidth={2} />
            <span>{isMac ? '⌘' : 'Ctrl'} K</span>
          </button>
        </div>

        {/* Mobile: compact cluster */}
        <div className="md:hidden flex items-center gap-2">
          <button
            type="button"
            onClick={onOpenCommand}
            aria-label="Open command palette"
            className="w-8 h-8 rounded-full flex items-center justify-center"
            style={{ background: 'var(--bone-deep)', color: 'var(--forest)' }}
          >
            <Command size={13} strokeWidth={2} />
          </button>
          <a
            href="#contact"
            className="mono text-[11px] uppercase tracking-[0.14em] px-3 py-1.5 rounded-full"
            style={{ background: 'var(--forest)', color: 'var(--cream)' }}
          >
            Say hi
          </a>
        </div>
      </div>
    </header>
  );
}
